import api from "@/services/api";
import type { Question } from "@/types/question";
import type {
	GetAllQuestionsParams,
	PaginatedChecklistQuestionResponse,
} from "../types";

export const checklistQuestionsService = {
	async getAllQuestions(params?: GetAllQuestionsParams) {
		const response = await api.get<PaginatedChecklistQuestionResponse>(
			"/api/checklistquestion/paginated",
			{ params }
		);
		return response.data;
	},

	async getQuestionById(id: number): Promise<Question> {
		const response = await api.get<Question>(`/api/checklistquestion/${id}`);
		return response.data;
	},
};
